import React from "react";
import { formatMile, SEVERITY_STYLES } from "./formatters";

const ConstructionSection = ({ roadWork }) => {
  if (roadWork.length === 0) {
    return (
      <p className="text-xs text-gray-500 dark:text-gray-400">
        No construction reported on this route.
      </p>
    );
  }

  return (
    <table className="w-full text-xs">
      <thead>
        <tr className="border-b text-left text-gray-500 dark:text-gray-400">
          <th className="py-1 pr-2 font-medium w-12">Mile</th>
          <th className="py-1 font-medium">Description</th>
        </tr>
      </thead>
      <tbody>
        {roadWork.map((rw, i) => (
          <tr key={rw.externalId || i} className="border-b last:border-0">
            <td className="py-1 pr-2 text-gray-500 dark:text-gray-400 align-top whitespace-nowrap">
              {formatMile(rw.distanceAlongRouteMeters)}
            </td>
            <td className="py-1 text-gray-700 dark:text-gray-300">
              <span
                className={`font-medium ${SEVERITY_STYLES[rw.severity] || "text-gray-600 dark:text-gray-400"}`}
              >
                {rw.locationDescription || ""}
              </span>
              {rw.locationDescription && rw.description ? " — " : ""}
              {rw.description}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ConstructionSection;
